import React from 'react';
import FieldContainer from '@common/FieldContainer';
import RegisteredCouponListVO, { RegisteredCouponVO } from '@domain/vo/coupons/RegisteredCouponVO';
import classnames from 'classnames/bind';
import styles from '../premium.module.scss';

const cx = classnames.bind(styles);

interface EventCodeItemProps {
  data: RegisteredCouponVO;
}

const EventCodeItem = ({ data }: EventCodeItemProps) => {
  return (
    <div className={cx('codeItemWrap')}>
      <span>{data.code}</span>
      <span className={cx('date', { isExpired: data.isExpired })}>{data.expireDateTimeText}</span>
    </div>
  );
};

const EmptyCodeItem = () => {
  return (
    <div className={cx('emptyCodeItemWrap')}>
      <span className={cx('emphasis')}>등록한 인증코드가 없어요.</span>
      <span>제휴서비스 신청 완료 후 확인할 수 있어요.</span>
    </div>
  );
};

interface EventCodeListProps {
  data: RegisteredCouponListVO;
}

const EventCodeList = ({ data }: EventCodeListProps) => {
  const nameContents = (
    <div className={cx('couponCountWrap')}>
      <span>등록 인증코드</span>
      <span className={cx('couponCount')}>{`총 ${data.registeredCoupons.length}개`}</span>
    </div>
  );

  const getCodeContents = () => {
    if (!data.registeredCoupons.length) return <EmptyCodeItem />;

    const codeItemEls = data.registeredCoupons.map((item, index) => <EventCodeItem key={index} data={item} />);
    return <div className={cx('scrollArea')}>{codeItemEls}</div>;
  };

  return (
    <FieldContainer name={nameContents}>
      <div className={cx('codeItemsArea')}>{getCodeContents()}</div>
    </FieldContainer>
  );
};

export default EventCodeList;
